import { lazy } from 'react'
import langConfig from "@configs/langConfig"
const {t} = langConfig

const UserManagement = [
    {
        path: '/admin/users',
        title : t('Users'),
        component: lazy(() => import('../../../views/admin/users-management')),
        meta: {
            isAdmin: true,
        }
    },
]

export default UserManagement